import { fetchRequestWithTypes } from './index.js';

export const GET_REFERRAL_REGISTRATION_REQUEST = 'GET_REFERRAL_REGISTRATION_REQUEST';
export const GET_REFERRAL_REGISTRATION_SUCCESS = 'GET_REFERRAL_REGISTRATION_SUCCESS';
export const GET_REFERRAL_REGISTRATION_ERRORED = 'GET_REFERRAL_REGISTRATION_ERRORED';

export const getReferralRegistration = () =>
	fetchRequestWithTypes({
		types: [
			GET_REFERRAL_REGISTRATION_REQUEST,
			GET_REFERRAL_REGISTRATION_SUCCESS,
			GET_REFERRAL_REGISTRATION_ERRORED,
		],
		request: {
			method: 'GET',
			path: '/referrals/api/v1/users/:uuid/views/registration',
		},
	});

export const PUT_REFERRAL_SOLICITOR_REQUEST = 'PUT_REFERRAL_SOLICITOR_REQUEST';
export const PUT_REFERRAL_SOLICITOR_SUCCESS = 'PUT_REFERRAL_SOLICITOR_SUCCESS';
export const PUT_REFERRAL_SOLICITOR_ERRORED = 'PUT_REFERRAL_SOLICITOR_ERRORED';

export const putReferralAgreement = (firstName) =>
	fetchRequestWithTypes({
		types: [
			PUT_REFERRAL_SOLICITOR_REQUEST,
			PUT_REFERRAL_SOLICITOR_SUCCESS,
			PUT_REFERRAL_SOLICITOR_ERRORED,
		],
		request: {
			method: 'PUT',
			path: '/referrals/api/v1/users/:uuid/referralAgreement',
			body: {
				first_name: firstName,
			},
		},
	});
